import React from 'react';

const values = [
  {
    title: 'Respeto y dignidad',
    description: 'Cada persona es válida tal y como es. Trabajamos desde la aceptación, sin juicios y sin imponer formas "correctas" de sentir o vivir.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Autodeterminación',
    description: 'Acompañamos a cada persona a tomar decisiones desde su propia brújula interna, construyendo una vida con sentido propio, coherente con sus valores y necesidades.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
  },
  {
    title: 'Compromiso social',
    description: 'Trabajamos con sensibilidad activa hacia la diversidad funcional, afectivo-sexual, de género y de contextos vitales. Aplicamos perspectiva de género y una mirada crítica hacia el estigma y la discriminación.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9" />
      </svg>
    ),
  },
  {
    title: 'Cercanía y humanidad',
    description: 'Cuidamos el vínculo terapéutico y ofrecemos un espacio cálido, seguro y accesible, donde la persona se sienta escuchada y acompañada.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    title: 'Rigor profesional',
    description: 'Nos basamos en evidencia científica actualizada y en un enfoque ético. Nos formamos continuamente para ofrecer un acompañamiento de calidad.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
];

export default function Values() {
  return (
    <section id="valores" className="section-padding bg-cream">
      <div className="container-narrow">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-forest)] opacity-70 mb-4 uppercase">
            Nuestros valores
          </span>
          <h2 className="mb-4">En qué creemos</h2>
          <p className="text-[var(--color-inerva-text-light)] max-w-2xl mx-auto">
            Inerva se fundamenta en una psicología ética, afirmativa y centrada en la persona.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.slice(0, 3).map((v, i) => (
            <div key={i} className="bg-white rounded-[var(--radius-xl)] p-8 border border-[rgba(61,79,61,0.08)]">
              <div className="w-14 h-14 rounded-full bg-[var(--color-inerva-mint)] flex items-center justify-center text-[var(--color-inerva-forest)] mb-5">
                {v.icon}
              </div>
              <h3 className="text-xl mb-3 font-serif">{v.title}</h3>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap justify-center gap-8 mt-8">
          {values.slice(3).map((v, i) => (
            <div key={i + 3} className="bg-white rounded-[var(--radius-xl)] p-8 border border-[rgba(61,79,61,0.08)] w-full sm:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div className="w-14 h-14 rounded-full bg-[var(--color-inerva-mint)] flex items-center justify-center text-[var(--color-inerva-forest)] mb-5">
                {v.icon}
              </div>
              <h3 className="text-xl mb-3 font-serif">{v.title}</h3>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
